module.exports = __webpack_public_path__ + "static/media/location-arrow.0a6f6224.svg";